import { render } from "./AddOnsDetail.vue?vue&type=template&id=683c5087&scoped=true"
import script from "./AddOnsDetail.vue?vue&type=script&lang=js"
export * from "./AddOnsDetail.vue?vue&type=script&lang=js"

import "./AddOnsDetail.vue?vue&type=style&index=0&id=683c5087&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-683c5087"

export default script

/* vue-cli-plugin-import-components */
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import UploadImage from "@/components/UploadImage.vue";
import Dropdown from "@/components/Dropdown.vue";
import Currency from "@/components/Currency.vue";
import BaseIcon from "@/components/BaseIcon.vue";
import BaseConfirmModal from "@/components/BaseConfirmModal.vue";
script.components = Object.assign({}, { Breadcrumbs, UploadImage, Dropdown, Currency, BaseIcon, BaseConfirmModal }, script.components);